export { default as PopularBrands } from "./PopularBrands";
export { PopularBrandsWrapper } from "./PopularBrandsWrapper";
